// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IShowBlackFridayEtazhiRequest,
  TShowBlackFridayEtazhiModel,
  IMappers,
  TShowBlackFridayEtazhiResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IIsShowBlackFridayEtazhiResponse } from '../../entities/is_show_black_friday_etazhi/IsShowBlackFridayEtazhiResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createShowBlackFridayEtazhiModel(
  parameters: IShowBlackFridayEtazhiRequest,
): TShowBlackFridayEtazhiModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'mortgage-subsidised-offers',
    pathApi: '/v1/show-black-friday-etazhi/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IShowBlackFridayEtazhiOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IShowBlackFridayEtazhiRequest;
}

export async function fetchShowBlackFridayEtazhi<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IShowBlackFridayEtazhiOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TShowBlackFridayEtazhiResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createShowBlackFridayEtazhiModel(parameters),
    config,
  )) as FetchResponse<TShowBlackFridayEtazhiResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIsShowBlackFridayEtazhiResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TShowBlackFridayEtazhiResponse>;
}
